module.exports = __webpack_public_path__ + "img/header-engagementRings100Carat@2x.d226737.webp";